/*
	引入
	import Mixins from '@/static/js/mixins.js';
	调用
	mixins: [Mixins],
*/

const MescrollMixin = {

	data() {
		return {
			isMobile: false,
		}
	},
	created() {
		this.getMobile();
		window.onresize = ()=>{
			this.getMobile();
		}
	},
	methods: {
		getMobile() {
			var _height = window.innerHeight,
				_width = window.innerWidth;
			if (_width < 800 && _height > _width) {
				this.isMobile = true;
			} else {
				this.isMobile = false;
			}
			console.log(this.isMobile)
		},
		onresize() {
			
		}
	},
}

export default MescrollMixin;
